// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"bfca6f54","72":"ab601af4","135":"810b51a9","144":"f3e4de4b","250":"3f45e6aa","357":"6e1cf634","553":"930bb76c","579":"b870477c","691":"19def0c8","794":"50674b9a","900":"fe45f651","909":"f58bd242"}[chunkId] + ".chunk.js";
};